module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_7042.596d71f2.png";